module.exports = __webpack_public_path__ + "static/img/user.4bf0773.png";


//////////////////
// WEBPACK FOOTER
// ./src/synagieChat/user.png
// module id = tTbE
// module chunks = 1